module.exports = __webpack_public_path__ + "img/template_ai_icon.4782e6c0.svg";